const redirectOptions = [
  {
    from: '/home/dashboard',
    to: '/welcome',
  },
  {
    from: '/home/chatbot',
    to: '/bots',
  },
  {
    from: '/flows',
    to: '/bots',
  },
  {
    from: '/signin',
    to: '/',
  },
  {
    from: '/notifications',
    to: '/attraction',
  },
  {
    from: '/campaign',
    to: '/attraction',
  },
  {
    from: '/sales',
    to: '/sales-chat/inbox',
  },
  {
    from: '/service',
    to: '/service/chat',
    exact: true,
  },
  {
    from: '/chatbot',
    to: '/chatbot/list',
    exact: true,
  },
  {
    from: '/broadcast',
    to: '/broadcast/homepage',
    exact: true,
  },
  {
    from: '/report',
    to: '/analysis/contacts-report',
    exact: true,
  },
]

// exact: only the bare route (ignoring a trailing slash) redirects, so real
// sub-routes like /service/tickets or /broadcast/sms are left untouched
const matchesRoute = (currentRoute, option) => {
  if (option.exact) {
    return currentRoute === option.from || currentRoute === `${option.from}/`
  }

  return currentRoute === option.from || currentRoute.startsWith(`${option.from}/`)
}

// Unlike redirectOptions above, these only make sense for ONE app context
// (SUITE/APP) — the route keeps working normally for the other context,
// it isn't being retired. Because of that they can't be resolved at boot
// (window.maestroContextType isn't known yet when redirectGuard() runs,
// before login) — they must be re-checked wherever the context is already
// known: after setAppContext() resolves, and on every client-side
// navigation via the single-spa:before-routing-event listener (src/index.js).
const contextDependentRedirectOptions = [
  {
    from: '/home/credentials', to: '/settings/channels', context: 'SUITE', exact: true,
  },
]

export const getContextDependentRedirect = ({ pathname, contextType }) => {
  const match = contextDependentRedirectOptions.find(
    (option) => option.context === contextType && matchesRoute(pathname, option),
  )

  return match ? match.to : null
}

// eslint-disable-next-line arrow-body-style
export default ({ navigateToUrl }) => {
  return async () => {
    const currentRoute = window.location.pathname

    const redirect = redirectOptions.find((option) => matchesRoute(currentRoute, option))

    if (redirect) {
      navigateToUrl(redirect.to)
    }
  }
}
